// API configuration for customer app
// In development, use proxy (/api) to avoid CORS issues
// In production, use the full backend URL from environment variable
const getApiBaseUrl = () => {
  // If environment variable is set, use it
  // IMPORTANT: REACT_APP_API_URL should NOT include /api suffix
  if (process.env.REACT_APP_API_URL) {
    const url = process.env.REACT_APP_API_URL;
    const cleanUrl = url.endsWith('/') ? url.slice(0, -1) : url;
    return cleanUrl.endsWith('/api') ? cleanUrl : `${cleanUrl}/api`;
  }

  // In production (Vercel) or development, use proxy/rewrite
  // The Vercel rewrite rule in vercel.json will forward /api/* to Railway backend
  // This makes requests appear same-origin, allowing cookies to work
  return '/api';
};

const API_BASE_URL = getApiBaseUrl();

// Debug logging
console.log('[Customer App] API_BASE_URL:', API_BASE_URL);
console.log('[Customer App] REACT_APP_API_URL:', process.env.REACT_APP_API_URL);

export const apiCall = async (endpoint, options = {}) => {
  const url = endpoint.startsWith('http') ? endpoint : `${API_BASE_URL}${endpoint}`;

  const defaultOptions = {
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
    },
  };

  const response = await fetch(url, { ...defaultOptions, ...options });

  // Status 300 is used for multiple stores - treat as success
  if (!response.ok && response.status !== 300) {
    // Try to get error message from response body
    const errorData = await response.json().catch(() => ({}));
    const errorMessage = errorData.error || errorData.message || `${response.status} ${response.statusText}`;

    // Create error with status code attached
    const error = new Error(errorMessage);
    error.status = response.status;
    error.statusText = response.statusText;
    throw error;
  }

  return response.json();
};

// Create api object with methods
export const api = {
  get: async (endpoint) => {
    return apiCall(endpoint, { method: 'GET' });
  },
  post: async (endpoint, data) => {
    return apiCall(endpoint, {
      method: 'POST',
      body: JSON.stringify(data)
    });
  },
  put: async (endpoint, data) => {
    return apiCall(endpoint, {
      method: 'PUT',
      body: JSON.stringify(data)
    });
  },
  delete: async (endpoint) => {
    return apiCall(endpoint, { method: 'DELETE' });
  }
};

export default api;
